export const MenuItems = [
  // {
  //   id: "admin-dashboard",
  //   moduleName: "Dashboard",
  //   orderNo: 1,
  //   url: "/dashboard",
  //   roles: ["Admin", "SuperAdmin"],
  // },
  {
    id: "loans",
    moduleName: "Loans",
    orderNo: 1,
    url: "/loans",
    roles: ["Admin"],
  },
  {
    id: "officers",
    moduleName: "Officers",
    orderNo: 2,
    url: "/officer-list",
    roles: ["Admin"],
  },
  // {
  //   id: "generate",
  //   moduleName: "Generate",
  //   orderNo: 3,
  //   roles: ["Admin", "SuperAdmin"],
  //   subMenu: [
  //     {
  //       id: "generate-reports",
  //       moduleName: "Generate Reports",
  //       orderNo: 1,
  //       url: "/generate-report",
  //       roles: ["Admin", "SuperAdmin"],
  //     },
  //     {
  //       id: "generate-workstations",
  //       moduleName: "Generate Workstations",
  //       orderNo: 2,
  //       url: "/generate-workstation",
  //       roles: ["Admin", "SuperAdmin"],
  //     },
  //   ],
  // },

];
